import { render, staticRenderFns } from "./EmailSmsLogSideMenu.vue?vue&type=template&id=4923146b"
import script from "./EmailSmsLogSideMenu.vue?vue&type=script&lang=js"
export * from "./EmailSmsLogSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4923146b')) {
      api.createRecord('4923146b', component.options)
    } else {
      api.reload('4923146b', component.options)
    }
    module.hot.accept("./EmailSmsLogSideMenu.vue?vue&type=template&id=4923146b", function () {
      api.rerender('4923146b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/emailsmslog/EmailSmsLogSideMenu.vue"
export default component.exports